import { request } from '../auth/client';
import type { AuditQuery, AuditRow, PaginatedResponse } from '@runik/shared';

export const auditKey = (query?: Partial<AuditQuery>) => ['audit', { ...(query ?? {}) }] as const;

export function listAudit(query: Partial<AuditQuery>) {
  const params = new URLSearchParams();
  if (query.page) params.set('page', String(query.page));
  if (query.limit) params.set('limit', String(query.limit));
  if (query.actorId) params.set('actorId', query.actorId);
  if (query.from) params.set('from', query.from);
  if (query.to) params.set('to', query.to);
  if (query.action) {
    for (const a of query.action) params.append('action', a);
  }
  return request<PaginatedResponse<AuditRow>>(`/api/audit?${params.toString()}`);
}

export function exportAuditCsvUrl(query: Partial<AuditQuery>): string {
  const params = new URLSearchParams();
  if (query.actorId) params.set('actorId', query.actorId);
  if (query.from) params.set('from', query.from);
  if (query.to) params.set('to', query.to);
  if (query.action) {
    for (const a of query.action) params.append('action', a);
  }
  return `/api/audit/export.csv?${params.toString()}`;
}
